import { render, staticRenderFns } from "./NanocrowdDefinitions.vue?vue&type=template&id=5bf68dae&scoped=true&"
import script from "./NanocrowdDefinitions.vue?vue&type=script&lang=js&"
export * from "./NanocrowdDefinitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf68dae",
  null
  
)

export default component.exports